import { useEffect, useState } from "react";
import { Button, Row, Col } from "react-bootstrap";
import Loader from "../../components/loader";
import UiButton from "../../components/button";
import TextInput from "../../components/textinput/TextInput";
import { ethers, BigNumber, providers } from "ethers";
import Web3 from "web3";
import {
  SecuritiesFactory,
  contractAddress,
} from "@verified-network/verified-sdk";
import { useNetworkOptions } from "../../context/contractDataLoaderService";
import VerticallyModal from "../../components/modal/VerticallyModal";
import { signMessage } from "../../utils/response";
import {
  SuccessToast,
  FailureToast,
  ToastOptions,
  networks,
  MarginIssueCategoryMarkers,
} from "../../utils/constants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Route, useHistory } from "react-router-dom";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../utils/helpers/networks";
import { useGlobal } from "../../context/globalContext";
import { getAllVerifiedCashBalances } from "../../utils/helpers";

const NULL_ADDRESS = "0x0000000000000000000000000000000000000000";

function Balance(props) {
  const history = useHistory();
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const { data: networkOptions } = useNetworkOptions();

  const handleModalHide = () => {
    setShowModal(false);
  };

  let factoryContract;
  if (provider && provider.getSigner && chainId && address) {
    factoryContract = new SecuritiesFactory(
      signer,
      contractAddress[chainId].SecuritiesFactory,
    );
  }
  const addBalance = async () => {
    if (props.balance.length == 0) {
      alert("Enter amount");
    }

    const securityAddress = props.security;
    setLoading(true);
    try {
      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account,
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions,
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await factoryContract._getMeeQuote(
          cashTokens[0]?.address,
          "addBalance",
          [
            securityAddress,
            NULL_ADDRESS, //transferor
            account, //transferee
            web3.utils.toWei(props.balance, "ether"),
          ],
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions,
          );

          return;
        }
      }

      await factoryContract
        .addBalance(
          securityAddress,
          NULL_ADDRESS, //transferor
          account, //transferee
          web3.utils.toWei(props.balance, "ether"), //amount,
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {},
        )
        .then((res) => {
          setLoading(false);
          if (res?.status === 0) {
            const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
            toast.success(SuccessToast(transactionLink), ToastOptions);
            if (MarginIssueCategoryMarkers.includes(props.productCategory)) {
              if (props.existingIssue) {
                props.setIssuedModalView(4);
              } else {
                props.updateModalView(4);
              }
            } else {
              if (props.existingIssue) {
                props.setIssuedModalView(3);
              } else {
                props.updateModalView(3);
              }
            }
          } else {
            toast.error("Transaction Failed", ToastOptions);
          }
        });
    } catch (err) {
      let error = { err };
      console.log(error);
      const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err?.transactionHash}`;
      setLoading(false);
      toast.error(FailureToast(transactionLink), ToastOptions);
    }
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="d-grid gap-2">
        <Row className="ml-1 align-items-center">
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Amount to issue</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Decimals supported"
                fieldType="number"
                required
                value={props.balance}
                onChange={(e) => props.updateBalance(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col className="pl-0">
              <UiButton
                onClick={() => {
                  if (web3 && chainId && signer && account) {
                    addBalance();
                  }
                }}
                buttonVariant="primary"
                buttonClass="SignUpButton flex-1 ml-0"
                buttonText="Add Balance"
                type="submit"
              />
            </Col>
          </Row>
        </Row>
      </div>
    </>
  );
}

export default function AddBalance(props) {
  return (
    <Route>
      <Balance {...props} />
    </Route>
  );
}
